import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IGroupReq } from '../../../models/groups.model'
import { doGetGroup, doUpdateGroup } from '../../../store/group.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/group/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';

interface IMatch {
  id: string;
}

const SystemGroupEdit: FC<RouteComponentProps> = ({ history }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { group, isLoading } = useSelector((state: RootState) => state.group);
  
  const match = useRouteMatch<IMatch>();
  const id = Number(match.params.id);

  useEffect(() => {
    getGroup(id);
  }, [])

  const getGroup = async (id: number) => {
    const res = await dispatch(doGetGroup(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: IGroupReq) => {
    const res = await dispatch(doUpdateGroup(id, req));
    
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push('/system/group');
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.group.title3')}
      />
      <Editor
        group={group || null}
        onSubmit={onSubmit}
      />
      <Footer />
    </div>
  )
}

export default SystemGroupEdit;
